import { render, staticRenderFns } from "./PedidosProductos.vue?vue&type=template&id=15ae194e"
import script from "./PedidosProductos.vue?vue&type=script&lang=js"
export * from "./PedidosProductos.vue?vue&type=script&lang=js"
import style0 from "./PedidosProductos.vue?vue&type=style&index=0&id=15ae194e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports